module.exports = __webpack_public_path__ + "static/media/5.b14a15d.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/test/5.wav
// module id = 5x6Y
// module chunks = 0